export default "__VITE_ASSET__4897c162__"